export default {
  get maintenance () {
    return {
      duration: process.env.REACT_APP_MAINTENANCE_DURATION,
      date: process.env.REACT_APP_MAINTENANCE_DATE
    }
  },

  get isMaintenanceScheduled () {
    const { duration, date } = this.maintenance
    return duration && date
  },

  get docUrl () {
    return process.env.REACT_APP_DOC_URL
  }
}
